import { render, staticRenderFns } from "./StudioSettingsTeachers.vue?vue&type=template&id=8ce2b6e2&scoped=true"
import script from "./StudioSettingsTeachers.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioSettingsTeachers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioSettingsTeachers.vue?vue&type=style&index=0&id=8ce2b6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce2b6e2",
  null
  
)

export default component.exports